import React from 'react'
import { images, fallback } from 'images/image-library'

const DEFAULT_BG = '#f3f4f6'

const BrandChip = ({ brand, size = 24, muted = false }) => {
  const brandKey = brand?.key
  const dimension = size * 0.82
  const label = brand?.name || ''

  const placeholder = (
    <img
      src={fallback.defaultBrand}
      alt={label}
      style={{ width: dimension, height: dimension, objectFit: 'contain' }}
    />
  )

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        background: DEFAULT_BG,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
        flexShrink: 0,
        overflow: 'hidden',
        ...(muted ? { filter: 'grayscale(0.7)', opacity: 0.92 } : {}),
      }}
    >
      {/*
        When the brand has a key we load its remote logo via <object> so we get
        a native, JS-free fallback: if the logo fails to load for any reason (no
        asset on S3, a name mismatch, a blocked/403 request) the browser renders
        the nested <img> placeholder instead. This works both when BrandChip is
        React-rendered (the popup) and when it is stringified via renderToString
        into a Leaflet marker icon — where a React onError handler would be
        dropped and never fire.

        With no key there is no remote logo to fetch, so we render the <img>
        placeholder directly. The bundled default-brand SVG has no viewBox, and
        an <object> ignores objectFit, so loading it as <object> data would
        render it at its intrinsic size instead of scaling to the chip; an <img>
        applies objectFit and scales it correctly.
      */}
      {brandKey ? (
        <object
          data={images.brandImage(brandKey)}
          type="image/svg+xml"
          aria-label={label}
          style={{ width: dimension, height: dimension, pointerEvents: 'none' }}
        >
          {placeholder}
        </object>
      ) : (
        placeholder
      )}
    </span>
  )
}

export { BrandChip }
